<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 overflow-hidden">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Avatar Size Rounded-Circle Example</h4>
          <ul class="nav nav-tabs mb-4" id="myTab4" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview4-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview4-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview4-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code4-tab"
                data-bs-toggle="tab"
                data-bs-target="#code4-tab-pane"
                type="button"
                role="tab"
                aria-controls="code4-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent4">
            <div
              class="tab-pane fade show active"
              id="preview4-tab-pane"
              role="tabpanel"
              aria-labelledby="preview4-tab"
              tabindex="0"
            >
              <div class="d-flex align-items-center gap-4 flex-wrap">
                <img
                  src="@/assets/images/user-68.jpg"
                  class="wh-87 rounded-circle"
                  alt="user"
                />
                <img
                  src="@/assets/images/user-68.jpg"
                  class="wh-77 rounded-circle"
                  alt="user"
                />
                <img
                  src="@/assets/images/user-68.jpg"
                  class="wh-67 rounded-circle"
                  alt="user"
                />
                <img
                  src="@/assets/images/user-68.jpg"
                  class="wh-57 rounded-circle"
                  alt="user"
                />
                <img
                  src="@/assets/images/user-68.jpg"
                  class="wh-47 rounded-circle"
                  alt="user"
                />
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code4-tab-pane"
              role="tabpanel"
              aria-labelledby="code4-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode4"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode4">
&lt;img src="@/assets/images/user-68.jpg" class="wh-87 rounded-circle" alt="user"&gt;
&lt;img src="@/assets/images/user-68.jpg" class="wh-77 rounded-circle" alt="user"&gt;
&lt;img src="@/assets/images/user-68.jpg" class="wh-67 rounded-circle" alt="user"&gt;
&lt;img src="@/assets/images/user-68.jpg" class="wh-57 rounded-circle" alt="user"&gt;
&lt;img src="@/assets/images/user-68.jpg" class="wh-47 rounded-circle" alt="user"&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 overflow-hidden">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Avatar Size Simple Rounded Example</h4>
          <ul class="nav nav-tabs mb-4" id="myTab5" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview5-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview5-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview5-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code5-tab"
                data-bs-toggle="tab"
                data-bs-target="#code5-tab-pane"
                type="button"
                role="tab"
                aria-controls="code5-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent5">
            <div
              class="tab-pane fade show active"
              id="preview5-tab-pane"
              role="tabpanel"
              aria-labelledby="preview5-tab"
              tabindex="0"
            >
              <div class="d-flex align-items-center gap-4 flex-wrap">
                <img
                  src="@/assets/images/screenshorts.jpg"
                  class="wh-87 rounded-3"
                  alt="screenshorts"
                />
                <img
                  src="@/assets/images/screenshorts.jpg"
                  class="wh-77 rounded-3"
                  alt="screenshorts"
                />
                <img
                  src="@/assets/images/screenshorts.jpg"
                  class="wh-67 rounded-3"
                  alt="screenshorts"
                />
                <img
                  src="@/assets/images/screenshorts.jpg"
                  class="wh-57 rounded-3"
                  alt="screenshorts"
                />
                <img
                  src="@/assets/images/screenshorts.jpg"
                  class="wh-47 rounded-3"
                  alt="screenshorts"
                />
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code5-tab-pane"
              role="tabpanel"
              aria-labelledby="code5-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode5"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode5">
&lt;img src="@/assets/images/screenshorts.jpg" class="wh-87 rounded-3" alt="screenshorts"&gt;
&lt;img src="@/assets/images/screenshorts.jpg" class="wh-77 rounded-3" alt="screenshorts"&gt;
&lt;img src="@/assets/images/screenshorts.jpg" class="wh-67 rounded-3" alt="screenshorts"&gt;
&lt;img src="@/assets/images/screenshorts.jpg" class="wh-57 rounded-3" alt="screenshorts"&gt;
&lt;img src="@/assets/images/screenshorts.jpg" class="wh-47 rounded-3" alt="screenshorts"&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4 pb-0">
          <h4 class="fs-18 mb-4">Avatar size rounded-circle example</h4>
          <ul class="nav nav-tabs mb-4" id="myTab3" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview3-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview3-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview3-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code3-tab"
                data-bs-toggle="tab"
                data-bs-target="#code3-tab-pane"
                type="button"
                role="tab"
                aria-controls="code3-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent3">
            <div
              class="tab-pane fade show active"
              id="preview3-tab-pane"
              role="tabpanel"
              aria-labelledby="preview3-tab"
              tabindex="0"
            >
              <div class="row">
                <div class="col-lg-6 mb-4">
                  <img
                    src="@/assets/images/screenshorts.jpg"
                    class="border border-3"
                    alt="screenshorts"
                  />
                </div>
                <div class="col-lg-6 mb-4">
                  <img
                    src="@/assets/images/screenshorts.jpg"
                    class="rounded-circle border border-3"
                    alt="screenshorts"
                  />
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code3-tab-pane"
              role="tabpanel"
              aria-labelledby="code3-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode3"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode3">
&lt;div class="row"&gt;
&lt;div class="col-lg-6 mb-4"&gt;
&lt;img src="@/assets/images/screenshorts.jpg" class="border border-3" alt="screenshorts"&gt;
&lt;/div&gt;
&lt;div class="col-lg-6 mb-4"&gt;
&lt;img src="@/assets/images/screenshorts.jpg" class="border rounded-circle border-3" alt="screenshorts"&gt;
&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Responsive Images</h4>
          <ul class="nav nav-tabs mb-4" id="myTab6" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview6-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview6-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview6-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code6-tab"
                data-bs-toggle="tab"
                data-bs-target="#code6-tab-pane"
                type="button"
                role="tab"
                aria-controls="code6-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent6">
            <div
              class="tab-pane fade show active"
              id="preview6-tab-pane"
              role="tabpanel"
              aria-labelledby="preview6-tab"
              tabindex="0"
            >
              <img
                src="@/assets/images/carousel-1.jpg"
                class="border-3 border-color-white"
                alt="carousel"
              />
            </div>
            <div
              class="tab-pane fade"
              id="code6-tab-pane"
              role="tabpanel"
              aria-labelledby="code6-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode6"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode6">
&lt;img src="@/assets/images/carousel-1.jpg" class="border-3 border-color-white" alt="carousel"&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import Prism from "prismjs";
import "prismjs/themes/prism.min.css";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Images",
  setup() {
    onMounted(() => {
      Prism.highlightAll();
    });
  },
});
</script>
